/**/import { defaultApi } from "@/config/httpClient";
import { getLanguageHeaders } from "@/config/i18n";
import { CreateLookupValueDto, EditableLookupValueDto, LookupValueDto,  LookupValueType,  ResultEditableLookupValueDto } from "@/generated/openapi/api";
import { OnbTableSortOptions } from "@/models/OnbTableColumnDefinition";
import { asSortString} from "@/utils/apiUtils";

class LookupValuesService {


  public getLookupValuesSprache(): Promise<LookupValueDto[]>{
    return this.getLookupValuesByLookupValueType("LANGUAGE" as LookupValueType)
  }

  public getLookupValuesTopic(): Promise<LookupValueDto[]>{
    return this.getLookupValuesByLookupValueType("TOPIC" as LookupValueType)
  }


public getLookupValuesByLookupValueType(lookupValueType?: LookupValueType, area?: string): Promise<LookupValueDto[]>{
    return defaultApi.findLookupValues(lookupValueType, area, 1000, undefined, undefined, getLanguageHeaders()).then(response => {
      if (response.data && response.data.content) {
        return response.data.content
      }
      return [] as LookupValueDto[]
    })
  }

  public getLookupValuesByAdmin(lookupValueType: string, area?: string, sortOptions?: OnbTableSortOptions): Promise<ResultEditableLookupValueDto> {
    const sortString = asSortString(sortOptions)
    return defaultApi.findLookupValuesByAdmin(lookupValueType, area, 1000, 0, sortString).then(response => {
      if (response && response.data) {
        return response.data
      }
      return {content: [], totalCount: 0} as ResultEditableLookupValueDto
    })
  }

  /**
   * Sucht ein Lookup-value aus der übergebenen Map (Map aus dem store)
   * @param lookUpValues
   * @param lookupType
   * @param id
   * @returns
   */
  public getLookupValueById(lookUpValues: Map<string, Array<LookupValueDto>>,lookupType: string, id: string): LookupValueDto{
    if (lookUpValues.has(lookupType) ){
      const lookups = lookUpValues.get(lookupType) || [];
      for( let i = 0; i <= lookups.length ; i++){
        if (lookups[i].id === id){
          return lookups[i]
        }
      }
    }
    return {} as LookupValueDto
  }

  /**
   * Lädt ein Lookup-Value von der API (für Verwaltungsapplikation)
   */
  public getLookupValueByIdByAdmin(id: string): Promise<EditableLookupValueDto> {
    return defaultApi.getLookupValueByAdmin(id).then(resp => {
      return resp.data
    })
  }

  public createLookupValueByAdmin(lookupValue: CreateLookupValueDto): Promise<void> {

    return defaultApi.createLookupValueByAdmin(lookupValue).then(_ => {
      return;
    })
  }

  public updateLookupValueByAdmin(lookupValue: EditableLookupValueDto): Promise<void> {
    return defaultApi.updateLookupValueByAdmin(lookupValue.id, lookupValue).then(_ => {
      return;
    })
  }

  public deleteLookupValueByAdmin(lookupValueId: string): Promise<void> {
    return defaultApi.deleteLookupValueByAdmin(lookupValueId).then(_ => {
      return;
    })
  }

}



const lookupValuesService = new LookupValuesService()
export default lookupValuesService
